import 'css-chunksrc/client/pages/zonesPage/header/navigation/styles.scss';export default {
  "navigation": "_navigation_dj4wh_1",
  "item": "_item_dj4wh_8",
  "icon": "_icon_dj4wh_14",
  "selectedItem": "_selectedItem_dj4wh_18",
  "selectedLink": "_selectedLink_dj4wh_24",
  "text": "_text_dj4wh_36",
  "link": "_link_dj4wh_43"
};